export const setupChromeStorageListenerForLogin = () => {
  chrome.storage.onChanged.addListener((changes) => {
    if (changes["lv-chrome-id"]?.newValue !== undefined) {
      window.location.reload();
    }
  });
};
